/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Area_HintInputs */

const cs_requirements_area_hint = /** @type {(inputs: Requirements_Area_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa, ulice, městská část nebo kraj a okruh kolem tohoto bodu.`)
};

const en_requirements_area_hint = /** @type {(inputs: Requirements_Area_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address, street, district, or region plus a radius around that point.`)
};

/**
* | output |
* | --- |
* | "Address, street, district, or region plus a radius around that point." |
*
* @param {Requirements_Area_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_area_hint = /** @type {((inputs?: Requirements_Area_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Area_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_area_hint(inputs)
	return cs_requirements_area_hint(inputs)
});